<template>
  <section class="deliveryDetailDiv">
    <section class="viewTitle">
      <viewTitle
        title="业务管理 / 车辆排队管理 / 成品出厂 / 查看车辆详情"
        :showReturn="true"
      />
    </section>

    <section class="p16">
      <!-- 模块一 -->
      <section>
        <div class="title">
          <div class="tag"></div>
          <span class="text">预约信息</span>
        </div>
        <div class="content">
          <el-row>
            <el-col :span="9">运输单位：{{ info.unit }}</el-col>
            <el-col :span="8">办理业务：{{ business.name }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="9">
              <span v-if="business.type === 1">产品线：</span>
              <span v-if="business.type === 0">业务子类：</span>
              {{ business_products_name.join("、") || "--" }}
            </el-col>
            <el-col :span="8">车牌号：{{ info.license_plate || "--" }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="9">
              车辆类型：<span v-if="Number(info.vehicle_type) === 1"
                >平板车</span
              >
              <span v-if="Number(info.vehicle_type) === 2">货柜车</span>
              <span v-if="Number(info.vehicle_type) === 3">槽罐车</span>
              <span v-if="Number(info.vehicle_type) === 4">其他</span>
              <span v-if="Number(info.vehicle_type) === 5">高栏车</span>
            </el-col>
            <el-col :span="8">司机姓名：{{ info.name || "--" }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="9">手机号码：{{ info.contact || "--" }}</el-col>
            <el-col :span="8">身份证号：{{ info.id_card || "--" }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="9"
              >预约类型：<span style="color: #008b5e;">普通预约</span></el-col
            >
            <el-col :span="8"
              >预约到厂时间：{{ formatBookingTime(rowDataObj.booking_day) }}
              {{ `${booking_time.begin_time}至${booking_time.end_time}` }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6"
              >身份证正反面：
              <div v-if="src.length > 0">
                <imagePlus
                  class="cardimg"
                  :src="src[0]"
                  :preview-src-list="srcList"
                  :imgListData="rowDataObj.file"
                  @imageRotateDeg="imageRotateDeg"
                  @imagePreHide="imagePreHide"
                >
                </imagePlus>
                <imagePlus
                  class="cardimg"
                  :src="src[1]"
                  :preview-src-list="srcList"
                  :imgListData="rowDataObj.file"
                  @imageRotateDeg="imageRotateDeg"
                  @imagePreHide="imagePreHide"
                >
                </imagePlus>
              </div>
            </el-col>
            <el-col :span="6"
              >驾驶证主副页：
              <div v-if="src.length > 0">
                <imagePlus
                  class="cardimg"
                  :src="src[2]"
                  :preview-src-list="srcList"
                  :imgListData="rowDataObj.file"
                  @imageRotateDeg="imageRotateDeg"
                  @imagePreHide="imagePreHide"
                >
                </imagePlus>
                <imagePlus
                  class="cardimg"
                  :src="src[3]"
                  :preview-src-list="srcList"
                  :imgListData="rowDataObj.file"
                  @imageRotateDeg="imageRotateDeg"
                  @imagePreHide="imagePreHide"
                >
                </imagePlus>
              </div>
            </el-col>
            <el-col :span="6"
              >行驶证主副页：
              <div v-if="src.length > 0">
                <imagePlus
                  class="cardimg"
                  :src="src[4]"
                  :preview-src-list="srcList"
                  :imgListData="rowDataObj.file"
                  @imageRotateDeg="imageRotateDeg"
                  @imagePreHide="imagePreHide"
                >
                </imagePlus>
                <imagePlus
                  class="cardimg"
                  :src="src[5]"
                  :preview-src-list="srcList"
                  :imgListData="rowDataObj.file"
                  @imageRotateDeg="imageRotateDeg"
                  @imagePreHide="imagePreHide"
                >
                </imagePlus>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>

      <!-- 模块二 -->
      <section style="padding-top: 10px;">
        <div class="title">
          <div class="tag"></div>
          <span class="text">报到信息</span>
        </div>
        <div class="content">
          <el-row>
            <el-col>
              报到时间：<span>{{ formatTime(report.report_time) }}</span>
              <div class="tips" v-if="isLate">
                <i class="el-icon-warning" style="color: #EC3F67"></i>
                {{
                  lateTime(
                    rowDataObj.booking_day,
                    booking_time.end_time,
                    report.report_time
                  )
                }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col
              >司机姓名：{{ report_info.name || "--" }}
              <div class="tips" v-if="info.name !== report_info.name">
                <i class="el-icon-warning" style="color: #EC3F67"></i>
                与预约信息不一致
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col
              >身份证号：{{ report_info.id_card || "--" }}
              <div class="tips" v-if="info.id_card !== report_info.id_card">
                <i class="el-icon-warning" style="color: #EC3F67"></i>
                与预约信息不一致
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col
              >手机号码：{{ report_info.contact || "--" }}
              <div class="tips" v-if="info.contact !== report_info.contact">
                <i class="el-icon-warning" style="color: #EC3F67"></i>
                与预约信息不一致
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col style="display: flex;">
              <div class="tbTitle">
                随行人员：
              </div>
              <div style="flex: 19;">
                <div
                  class="tbCell"
                  v-for="(item, index) in report_entourage"
                  :key="index"
                >
                  <div class="cellLeft">
                    随行人员
                  </div>
                  <div class="cellRight">
                    <div class="left">姓名：</div>
                    <div class="right">{{ item.name }}</div>
                  </div>
                  <div class="cellRight">
                    <div class="left">身份证：</div>
                    <div class="right">{{ item.id_card }}</div>
                  </div>
                  <div class="cellRight">
                    <div class="left">手机号码：</div>
                    <div class="right">{{ item.contact }}</div>
                  </div>
                </div>
                <div
                  v-if="
                    String(report_entourage) === 'undefined' ||
                      report_entourage.length === 0
                  "
                >
                  --
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>

      <!-- 模块三 -->
      <section style="padding-top: 10px;">
        <div class="title">
          <div class="tag"></div>
          <span class="text">排队信息</span>
        </div>
        <div class="content">
          <el-row>
            <el-col>
              进厂时间：{{ formatTime(report.into_factory_time) }}
            </el-col>
          </el-row>
          <el-row>
            <el-col style="display: flex;">
              <div class="tbTitle">
                详细信息：
              </div>
              <div style="flex: 19;">
                <div class="tbCell" v-for="(item, index) in queue" :key="index">
                  <div class="cellLeft">
                    排队信息
                  </div>
                  <div class="cellRight">
                    <div class="left">产品线：</div>
                    <div class="right">{{ item.business_name }}</div>
                  </div>
                  <div class="cellRight">
                    <div class="left">排队编号：</div>
                    <div class="right">
                      {{ `${item.code}` === "" ? "--" : `${item.code}` }}
                    </div>
                  </div>
                  <div class="cellRight">
                    <div class="left">当前状态：</div>
                    <div class="right">
                      {{
                        Number(item.loading_state) === 0
                          ? `${queueState[item.queue_state]}`
                          : `${loadState[item.loading_state]}`
                      }}
                    </div>
                  </div>
                  <div class="cellRight">
                    <div class="left">当前排位：</div>
                    <div class="right">
                      <span
                        v-if="
                          Number(item.loading_state) === 0 &&
                            Number(item.queue_state) === 1
                        "
                      >
                        第{{ item.ranking }}位
                      </span>
                      <span v-else>--</span>
                    </div>
                  </div>
                </div>
                <div v-if="String(queue) === 'undefined' || queue.length === 0">
                  --
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </section>

      <!-- 模块四 -->
      <!-- <section>
      <div class="title">
        <div class="tag"></div>
        <span class="text">过磅信息</span>
      </div>
      <div class="content">
        <el-row>
          <el-col>
            过磅状态：30吨
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            过磅数据：30吨
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            过磅时间：30吨
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            回磅数据：30吨
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            回磅数据：30吨
          </el-col>
        </el-row>
      </div>
    </section> -->

      <!-- 模块五 -->
      <section>
        <div class="timeLine">
          <div class="timeBlock">
            <div class="title">进厂前</div>
            <el-timeline id="firstTimeline">
              <el-timeline-item
                v-for="(activity, index) in activities1"
                :key="index"
                :icon="activity.icon"
                :type="activity.type"
                :color="activity.color"
                :size="activity.size"
                :timestamp="activity.timestamp"
              >
                <!-- {{ activity.content }} -->
                <div v-html="activity.content"></div>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div class="timeBlock" v-if="String(report) !== 'undefined'">
            <div class="title">进厂后</div>
            <el-timeline id="secondTimeline">
              <el-timeline-item
                v-for="(activity, index) in activities2"
                :key="index"
                :icon="activity.icon"
                :type="activity.type"
                :color="activity.color"
                :size="activity.size"
                :timestamp="activity.timestamp"
              >
                <!-- {{ activity.content }} -->
                <template v-if="Number(activity.is_evaluate) === 1">
                  <el-popover
                    :ref="'popoverevaluate' + index"
                    placement="top-start"
                    :width="
                      activity.evaluateData.operator_type == 2 ? '400' : '330'
                    "
                    :visible="activity.evaluateData.visible"
                    trigger="click"
                  >
                    <template>
                      <p
                        style=" font-size: 16px; margin: 0; padding: 0 0 5px 0; font-size: large;"
                      >
                        查看篷布防护详情
                      </p>
                      <el-form
                        :label-width="
                          activity.evaluateData.operator_type == 2
                            ? '170px'
                            : '100px'
                        "
                        class="evaluateFrom"
                      >
                        <el-form-item label="由谁盖篷布：">
                          <span>{{ activity.evaluateData.userName }}</span>
                        </el-form-item>
                        <el-form-item
                          v-if="activity.evaluateData.operator_type == 1"
                          label="服务评分："
                        >
                          <el-rate
                            v-model="activity.evaluateData.val"
                            disabled
                            show-score
                            :text-color="activity.evaluateData.color"
                            :score-template="activity.evaluateData.text"
                          >
                          </el-rate>
                        </el-form-item>
                        <el-form-item
                          v-if="activity.evaluateData.operator_type == 2"
                          label="自行做篷布防护的原因："
                        >
                          <span
                            style="white-space: pre-wrap;"
                            v-html="activity.evaluateData.self_reason"
                          ></span>
                        </el-form-item>
                        <el-form-item label="意见反馈：">
                          <span
                            v-if="
                              activity.evaluateData.content &&
                                activity.evaluateData.content.length > 0
                            "
                            style="white-space: pre-wrap;"
                            v-html="activity.evaluateData.content"
                          ></span>
                          <span v-else>--</span>
                        </el-form-item>
                        <el-form-item label="提交时间：">
                          <span>{{ activity.timestamp }}</span>
                        </el-form-item>
                        <el-form-item label="">
                          <div style="text-align: right;">
                            <el-button
                              slot="reference"
                              size="small"
                              @click="hideEvaluateData(index)"
                              >关闭</el-button
                            >
                          </div>
                        </el-form-item>
                      </el-form>
                    </template>
                  </el-popover>
                  <div>
                    <span
                      style=" cursor: pointer;"
                      @click="
                        activity.evaluateData.visible = !activity.evaluateData
                          .visible
                      "
                      v-popover="'popoverevaluate' + index"
                      v-html="activity.content"
                    ></span>
                  </div>
                </template>
                <template v-else>
                  <div v-html="activity.content"></div>
                </template>
              </el-timeline-item>
            </el-timeline>
          </div>
        </div>
      </section>

      <!-- 模块五 -->
      <section>
        <div style="margin-top: 30px;">
          <el-button
            @click="moveUp('moveOne')"
            type="primary"
            size="small"
            v-if="
              recentQueueObj.loading_state === 0 &&
                recentQueueObj.queue_state === 1
            "
            >上移一位</el-button
          >
          <el-button
            @click="moveUp('moveTop')"
            type="primary"
            size="small"
            v-if="
              recentQueueObj.loading_state === 0 &&
                recentQueueObj.queue_state === 1
            "
            >置顶</el-button
          >
          <el-button
            @click="moveUp('stop')"
            type="warning"
            size="small"
            style="color: white;"
            v-if="
              recentQueueObj.loading_state === 0 &&
                recentQueueObj.queue_state === 1
            "
            >终止</el-button
          >
          <!-- 重新排队 已停止（已过号，已失效） -->
          <el-button
            @click="moveUp('reQueue')"
            type="primary"
            size="small"
            v-if="
              recentQueueObj.loading_state === 0 &&
                (recentQueueObj.queue_state === 3 ||
                  recentQueueObj.queue_state === 4)
            "
            >重新排队</el-button
          >
          <!-- 恢复排位 已停止 -->
          <el-button
            @click="moveUp('reRank')"
            type="primary"
            size="small"
            v-if="
              recentQueueObj.loading_state === 0 &&
                recentQueueObj.queue_state === 3
            "
            >恢复排位</el-button
          >
          <!-- 终止装车 装车中 -->
          <el-button
            @click="moveUp('rejectLoad')"
            type="warning"
            size="small"
            v-if="
              recentQueueObj.loading_state === 1 ||
                recentQueueObj.loading_state === 2 ||
                recentQueueObj.loading_state === 3 ||
                recentQueueObj.loading_state === 4
            "
            >终止装车</el-button
          >
          <!-- <el-button
          @click="
            $router.push({
              path: '/rhqy/service/queue/DeliveryList'
            })
          "
          >返回</el-button
        > -->
        </div>
      </section>

      <el-dialog :visible.sync="dialogParams.dialogMoveUpShow" width="30%">
        <template slot="title">
          <div style="font-size: 18px;">
            <i
              class="el-icon-success"
              style="color: #2acdcf;"
              v-if="dialogParams.title === '操作成功'"
            ></i>
            {{ dialogParams.title }}
          </div>
        </template>
        <div>
          <div v-html="dialogMoveUpContent"></div>
        </div>
        <span
          slot="footer"
          class="dialog-footer"
          v-if="dialogParams.title === '确认提醒'"
        >
          <el-button
            @click="dialogParams.dialogMoveUpShow = false"
            size="small"
          >
            取 消
          </el-button>
          <el-button type="primary" @click="confirmMoveUp" size="small">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import moment from "moment";
import viewTitle from "@/components/viewTitle";
import imagePlus from "@/components/elementPlus/packages/image/index.js";

export default {
  data() {
    return {
      params: {
        keyword: "", // 关键字搜索
        name: "珠海坚力运输有限公司",
        remark: "成品提货",
        license: "粤C80394"
      },

      dialogParams: {
        title: "确认提醒",
        dialogMoveUpShow: false, // 上移一位弹窗
        dialogType: "" // 弹窗类型
      },
      rowDataObj: {}, // obj
      business_products: {}, // 产品线
      business_products_name: [], // 产品线名称
      business: {}, // 业务
      booking_time: {}, // 预约时间
      info: {}, // 预约信息
      file: {}, // 预约文件
      report: {}, // 报到
      report_info: {}, // 报到信息
      report_entourage: {}, // 随行人员
      log: {}, // 日志
      queue: {}, // 排队信息
      isLate: false,
      dialogMoveUpContent: "",
      src: [],
      srcList: [],
      activities1: [],
      activities2: [],
      recentQueueObj: "", // 当前的排队状态
      // queueState: [
      //   "排队中",
      //   "叫号中",
      //   "已过号",
      //   "等待装货",
      //   "拒绝装货",
      //   "装货中",
      //   "装货完成",
      //   "已完成",
      //   "已终止",
      //   "已失效"
      // ],
      // colorOption: [
      //   "#008B5E",
      //   "#008B5E",
      //   "#EC3F67",
      //   "#008B5E",
      //   "#EC3F67",
      //   "#008B5E",
      //   "#008B5E",
      //   "#008B5E",
      //   "#EC3F67",
      //   "#999999"
      // ],
      queueState: [
        "",
        "排队中",
        "叫号中",
        "已过号",
        "已失效",
        "已完成",
        "已终止"
      ],
      loadState: [
        "未开始",
        "等待装货",
        "拒绝装货",
        "装货中",
        "装货完成",
        "已完成",
        "已终止"
      ],
      imgChangeList: [], //記錄圖片旋轉記錄
      tarpaulin_comment: {}
    };
  },

  components: {
    viewTitle,
    imagePlus
  },

  async activated() {},

  created() {},

  mounted() {
    this.getDetail();
  },

  methods: {
    imagePreHide() {
      console.log(this.imgChangeList);
      this.imgChangeList.forEach(async (RotateItem, index) => {
        if (RotateItem != 0) {
          let id = this.rowDataObj.file[index].id;
          let real_path = this.rowDataObj.file[index].real_path;
          await this.$common
            .http({
              url: "/api/queue/admin/update_booking_info_file",
              data: {
                id: id,
                url: real_path,
                rotate_degrees: RotateItem
              },
              noLoading: true
            })
            .then(res => {
              let real_path = res.data.data;
              let file = this.rowDataObj.file[index];
              file.real_path = real_path;
              this.$set(this.rowDataObj.file, index, file);
              this.$set(this.src, index, real_path);
              this.$set(this.srcList, index, real_path);
            });
        }
      });
      for (let i = 0; i < this.imgChangeList.length; i++) {
        this.imgChangeList[i] = 0;
      }
    },
    imageRotateDeg(items, num, index) {
      console.log("請求旋轉圖片接口", items, num, index);
      this.imgChangeList[index] = this.imgChangeList[index] + (0 - num);
      console.log(this.imgChangeList);
    },
    // 获取详情
    async getDetail() {
      this.activities1 = [];
      this.activities2 = [];
      this.business_products_name = [];
      await this.$common
        .http({
          url: "/api/queue/admin/query_queue_detail",
          data: {
            booking_info_id: this.booking_info_id,
            queue_id: this.id
          }
        })
        .then(res => {
          console.log(res.data.data);
          this.rowDataObj = res.data.data;
          this.business_products = this.rowDataObj.business.sub_business; // 产品线
          this.business = this.rowDataObj.business; // 业务
          this.booking_time = this.rowDataObj.booking_time; // 预约时间
          this.info = this.rowDataObj.info; // 预约信息
          this.file = this.rowDataObj.file; // 预约文件
          this.report = this.rowDataObj.report; // 报到
          this.report_info = this.rowDataObj.report_info; // 报到信息
          this.report_entourage = this.rowDataObj.report_entourage; // 随行人员
          this.log = this.rowDataObj.log; // 日志
          this.queue = this.rowDataObj.queue; // 排队信息
          this.tarpaulin_comment = this.rowDataObj.tarpaulin_comment || {}; //盖篷布评价信息
          let rateArray = ["非常不满意", "不满意", "一般", "满意", "非常满意"];
          // 当前的排队状态
          this.queue.forEach(item => {
            if (item.id === this.id) {
              this.recentQueueObj = item;
            }
          });
          for (let i = 0; i < this.log.length; i++) {
            if (this.log[i].type === 0) {
              this.activities1.push({
                content: this.log[i].note,
                timestamp: this.formatTime(this.log[i].create_time),
                color: "#229A73"
              });
            } else {
              if (Number(this.log[i].event_type) === 33) {
                this.activities2.push({
                  content: this.log[i].note,
                  timestamp: this.formatTime(this.log[i].create_time),
                  color: "#00c8d2",
                  evaluateData: {
                    operator_type: this.tarpaulin_comment.operator_type,
                    userName:
                      Number(this.tarpaulin_comment.operator_type) === 1
                        ? "现场工作人员"
                        : "自己",
                    val: Number(this.tarpaulin_comment.score),
                    color: "#ff9900",
                    text: rateArray[Number(this.tarpaulin_comment.score) - 1],
                    content: this.tarpaulin_comment.feedback,
                    self_reason: this.tarpaulin_comment.self_reason,
                    visible: false
                  },
                  is_evaluate: 1
                });
              } else {
                this.activities2.push({
                  content: this.log[i].note,
                  timestamp: this.formatTime(this.log[i].create_time),
                  color: "#00c8d2"
                });
              }
              // this.activities2.push({
              //   content: this.log[i].note,
              //   timestamp: this.formatTime(this.log[i].create_time),
              //   color: "#00c8d2"
              // });
            }
          }
          // 照片
          this.imgChangeList = [];
          for (let i = 0; i < this.file.length; i++) {
            this.imgChangeList.push(0);
            this.src.splice(
              Number(this.file[i].type),
              0,
              this.file[i].real_path
            );
          }
          this.srcList = this.src;
          // 产品线名称数组
          this.business_products.forEach(item => {
            this.business_products_name.push(item.name);
          });
          // this.rowDataObj.state = 7;
          // this.report.state = 2;
          // this.popParams.status =
          //   String(this.report) !== "undefined" ? this.report.state : "";
        });
    },

    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },

    // 格式化实例时间
    formatBookingTime(str) {
      let str1 = String(str);
      if (moment().year() === Number(str1.substring(0, 4))) {
        return `${str1.substring(4, 6)}月${str1.substring(6, 8)}日`;
      } else {
        return `${str1.substring(0, 4)}年
          ${str1.substring(4, 6)}月
          ${str1.substring(6, 8)}日`;
      }
    },

    // 计算迟到时间
    lateTime(bookingDay, bookingTime, reportTime) {
      let str1 = String(bookingDay);
      let str2 = `${str1.substring(0, 4)}-${str1.substring(
        4,
        6
      )}-${str1.substring(6, 8)} ${bookingTime}`;
      // )}-${str1.substring(6, 8)} 14:00`;
      if (reportTime - moment(str2, "YYYY-MM-DD HH:mm").unix() > 0) {
        this.isLate = true;
        let min = Math.floor(
          (reportTime - moment(str2, "YYYY-MM-DD HH:mm").unix()) / 60
        );
        if (min > 60) {
          return `迟到大于1小时(${min}分钟)`;
        } else {
          return `迟到${min}分钟`;
        }
      }
    },

    // 上移一位
    moveUp(tag) {
      console.log(tag);
      this.dialogParams.dialogType = tag;
      if (tag === "moveOne") {
        this.dialogMoveUpContent = `“<span class="color67">${this.info.license_plate}</span>”当前处于<span class="color67">第${this.recentQueueObj.ranking}位</span>，确定要<span class="color67">上移一位</span>吗？`;
      } else if (tag === "moveTop") {
        this.dialogMoveUpContent = `“<span class="color67">${this.info.license_plate}</span>”当前处于<span class="color67">第${this.recentQueueObj.ranking}位</span>，确定要<span class="color67">置顶到第1位</span>吗？`;
      } else if (tag === "stop") {
        this.dialogMoveUpContent = `确定要终止“<span class="color67">${this.info.license_plate}</span>”的排队吗？这将从排队队列中移除该车辆，车辆将无法被叫号！`;
      } else if (tag === "reQueue") {
        this.dialogMoveUpContent = `确定要对“<span class="color67">${this.info.license_plate}</span>”重新排队吗？这意味着车辆要从最后一位重新开始排队！`;
      } else if (tag === "reRank") {
        this.dialogMoveUpContent = `确定要对“<span class="color67">${this.info.license_plate}</span>”恢复排位吗？这意味着车辆将立即加入排队并处于第1位！`;
      } else if (tag === "rejectLoad") {
        this.dialogMoveUpContent = `确定要终止“<span class="color67">${this.info.license_plate}</span>”的装车吗？`;
      }
      this.dialogParams.dialogMoveUpShow = true;
      this.dialogParams.title = "确认提醒";
    },

    // 确认操作
    confirmMoveUp() {
      this.dialogParams.dialogMoveUpShow = false;
      if (this.dialogParams.title === "确认提醒") {
        // this.dialogParams.dialogMoveUpShow = false;
        let url = "";
        let text = "";
        // setTimeout(() => {
        if (this.dialogParams.dialogType === "moveOne") {
          // this.dialogMoveUpContent =
          url = "/api/queue/admin/move_up_queue";
          text = `“${this.info.license_plate}”已成功上移一位。`;
        } else if (this.dialogParams.dialogType === "moveTop") {
          url = "/api/queue/admin/set_top_queue";
          text = `“${this.info.license_plate}”已成功置顶。`;
        } else if (this.dialogParams.dialogType === "stop") {
          url = "/api/queue/admin/remove_queue";
          text = `已成功从排队队列中移除“${this.info.license_plate}”`;
        } else if (this.dialogParams.dialogType === "reQueue") {
          url = "/api/queue/admin/afresh_rank";
          text = `“${this.info.license_plate}”已成功重新排队。`;
        } else if (this.dialogParams.dialogType === "reRank") {
          url = "/api/queue/admin/restore_rank";
          text = `“${this.info.license_plate}”已成功恢复排位。`;
        } else if (this.dialogParams.dialogType === "rejectLoad") {
          url = "/api/queue/admin/stop_loading_queue";
          text = `“${this.info.license_plate}”已成功终止装车。`;
        }
        // this.dialogParams.title = "操作成功";
        // this.dialogParams.dialogMoveUpShow = true;
        // }, 1000);

        this.$common
          .http({
            url: url,
            data: {
              queue_id: this.id
            }
          })
          .then(() => {
            this.getDetail();
            this.$common.pcToastSuccess(`${text}`);
          });
        // 自动关闭弹窗
        // setTimeout(() => {
        //   this.dialogParams.dialogMoveUpShow = false;
        // }, 3000);
      }
      //  else {
      //   this.dialogParams.dialogMoveUpShow = false;
      // }
    },
    hideEvaluateData() {
      document.getElementsByTagName("body")[0].click();
    }
  },

  computed: {
    id() {
      return this.$route.query.id;
    },
    booking_info_id() {
      return this.$route.query.booking_info_id;
    },
    indexText() {
      return index => {
        if (Number(index) < 10) {
          return "0" + (index + 1).toString();
        } else {
          return index;
        }
      };
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/css/common";
.deliveryDetailDiv {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  // padding: 16px;
  overflow: auto;
  & > .header {
    margin: 0px 0 24px 0;
    font-size: 20px;
    line-height: 20px;
    color: #4a4a4a;
  }

  .title {
    & > .tag {
      display: inline-block;
      height: 21px;
      background: #00a0fa;
      width: 5px;
      margin-right: 7px;
      vertical-align: bottom;
    }
    & > .text {
      font-size: 18px;
      color: #333333;
      font-weight: bold;
    }
  }

  .content {
    margin: 16px 11px;
    font-size: 14px;
    color: #333;
    line-height: 30px;
    .cardimg {
      width: 90px;
      height: 56px;
      margin-top: 7px;
      margin-right: 17px;
    }
    .tips {
      display: inline-block;
      margin-left: 10px;
      font-size: 11px;
      color: #ec3f67;
    }
    // 随行人员
    .tbTitle {
      display: inline-block;
      vertical-align: top;
    }
    .tbCell {
      display: inline-block;
      text-align: center;
      margin: 8px 20px 10px 0px;
      & > .cellLeft {
        width: 280px;
        line-height: 35px;
        font-size: 16px;
        background: rgb(247, 247, 247);
        border-radius: 4px 4px 0px 0px;
      }
      & > .cellRight {
        display: flex;
        font-size: 12px;
        & > .left {
          flex: 1.2;
          border: 1px solid #f7f7f7;
          text-align: right;
          padding: 0px 8px 0px 0px;
        }
        & > .right {
          flex: 2;
          border: 1px solid #f7f7f7;
          border-left: 0px;
          text-align: left;
          padding: 0px 0px 0px 15px;
        }
      }
    }
  }
  // 时间线
  .timeLine {
    display: flex;
    margin-top: 30px;
    & > .timeBlock {
      padding: 0px 35px;
      background: #f2f9f7;
      margin-right: 20px;
      width: 360px;
      & > .title {
        text-align: center;
        line-height: 56px;
        font-feature-settings: 18px;
      }
    }
  }

  .el-image__inner {
    object-fit: cover;
  }
}
</style>
<style lang="less">
.el-popover {
  .evaluateFrom {
    max-height: 450px;
    overflow: auto;
    padding-right: 10px;
    .el-form-item {
      margin-bottom: 0;
      .el-form-item__label {
        color: #999999;
      }
      .el-rate {
        padding-top: 9px;
      }
      .el-form-item__content,
      .el-form-item__label {
        line-height: 30px;
      }
    }
    .el-rate__text {
      font-size: 12px;
    }
  }
}
</style>
